import api from "../api/api";
import IDataExportModel from "../interfaces/IDataExportModel";

export default class ExportApiService {
    async export(data: IDataExportModel): Promise<void> {
        await api.post("/export/exportCsvToEmail", data);
    }
}